/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_2_LinkInputs */

const en_mk_sec_2_link = /** @type {(inputs: Mk_Sec_2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage tokens`)
};

const id_mk_sec_2_link = /** @type {(inputs: Mk_Sec_2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola token`)
};

/**
* | output |
* | --- |
* | "Manage tokens" |
*
* @param {Mk_Sec_2_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_2_link = /** @type {((inputs?: Mk_Sec_2_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_2_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_2_link(inputs)
	return en_mk_sec_2_link(inputs)
});